import React from 'react'
import propeller from '../../assets/propeller.png'
import './block-ui.less'

const BlockUI: React.FC = () => (
  <div className="block-ui">
    <div className="deem" />
    <img className="propeller" src={propeller} alt="propeller" />
  </div>
)

export default BlockUI
